export function normalizePhoneNumber(phoneNumber) {
  const normalizedPhoneNumber = phoneNumber?.replace(/[^0-9+]/g, "");

  // Numéro français standard à 10 chiffres sans préfixe +33
  if (
    normalizedPhoneNumber?.[0] === "0" &&
    normalizedPhoneNumber?.[1] !== "0" &&
    normalizedPhoneNumber?.length === 10
  ) {
    return "+33" + normalizedPhoneNumber.substring(1);
  }

  return normalizedPhoneNumber;
}
